import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import _isFunction from "lodash/isFunction";
import "core-js/modules/es.array.is-array.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Paper, Button, PartnerDataForm, PartnerDetails } from 'components';
import { jsx as ___EmotionJSX } from "@emotion/react";

var PartnerDetailsTab = function PartnerDetailsTab(_ref) {
  var partner = _ref.partner,
      onUpdate = _ref.onUpdate;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isEdit = _useState2[0],
      setIsEdit = _useState2[1];

  var handleClose = function handleClose() {
    return setIsEdit(false);
  };

  var handleUpdate = function handleUpdate(data) {
    _isFunction(onUpdate) && onUpdate(data);
    setIsEdit(false);
  };

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Row, {
    backgroundColor: "white"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(Paper, {
    header: function header(_ref2) {
      var css = _ref2.css;
      return ___EmotionJSX("div", {
        css: css
      }, ___EmotionJSX("h5", null, "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u0437\u0430 \u043F\u0430\u0440\u0442\u043D\u044C\u043E\u0440\u0430"), !isEdit && ___EmotionJSX(Button, {
        small: true,
        onClick: function onClick() {
          return setIsEdit(function (prev) {
            return !prev;
          });
        }
      }, "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u0430\u0439"));
    },
    margin: "0 0 2em 0"
  }, isEdit ? ___EmotionJSX(PartnerDataForm, {
    data: partner,
    onSubmit: handleUpdate,
    onClose: handleClose
  }) : ___EmotionJSX(PartnerDetails, {
    partner: partner
  })))));
};

PartnerDetailsTab.propTypes = {
  partner: PropTypes.object,
  onUpdate: PropTypes.func
};
export default PartnerDetailsTab;